import type { UniDriver } from '@wix/wix-ui-test-utils/unidriver';

export const wixDesignSystemProviderDriverFactory = (base: UniDriver) => {
  return {
    exists: async () => base.exists(),
    element: async () => base.getNative(),
    isNewColorsBrandingEnabled: async () =>
      (await base.attr('data-newcolorsbranding')) === 'true',
  };
};

export type WixDesignSystemProviderUniDriver = ReturnType<
  typeof wixDesignSystemProviderDriverFactory
>;
